export const DEFAULT_SHARE_ORIGIN = process.env.REACT_APP_SHARE_ORIGIN || 'https://sharabl.co.za';

export const normaliseCustomDomain = (domain = '') => domain
  .trim()
  .replace(/^https?:\/\//i, '')
  .replace(/\/.*$/, '')
  .toLowerCase();

export const encodeShareAssetId = (value = '') => {
  const text = String(value);
  if (!text) return '';

  try {
    const binary = encodeURIComponent(text).replace(/%([0-9A-F]{2})/g, (_, hex) => (
      String.fromCharCode(parseInt(hex, 16))
    ));
    return btoa(binary)
      .replace(/\+/g, '-')
      .replace(/\//g, '_')
      .replace(/=+$/, '');
  } catch (error) {
    return encodeURIComponent(text);
  }
};

export const decodeShareAssetId = (value = '') => {
  const text = String(value || '').trim();
  if (!text) return '';

  try {
    const base64 = text
      .replace(/-/g, '+')
      .replace(/_/g, '/')
      .padEnd(Math.ceil(text.length / 4) * 4, '=');
    const binary = atob(base64);
    const encoded = Array.from(binary, (character) => (
      `%${character.charCodeAt(0).toString(16).padStart(2, '0')}`
    )).join('');
    return decodeURIComponent(encoded);
  } catch (error) {
    try {
      return decodeURIComponent(text);
    } catch (decodeError) {
      return text;
    }
  }
};

export const buildShareUrl = (link) => {
  const slug = link?.slug || 'untitled-share';
  const customDomain = link?.useCustomDomain
    ? normaliseCustomDomain(link.customDomain)
    : '';
  if (customDomain) {
    return `https://${customDomain}/${slug}`;
  }

  return `${DEFAULT_SHARE_ORIGIN}/${slug}`;
};

export const buildAssetShareUrl = (linkOrShareUrl, asset) => {
  const baseUrl = typeof linkOrShareUrl === 'string'
    ? linkOrShareUrl
    : buildShareUrl(linkOrShareUrl);
  const assetId = asset?.id ? String(asset.id).trim() : '';
  if (!assetId) return baseUrl;

  try {
    const url = new URL(baseUrl);
    const slug = typeof linkOrShareUrl === 'string'
      ? url.pathname.replace(/^\/+/, '').replace(/\/+$/, '').split('/')[0]
      : linkOrShareUrl?.slug || url.pathname.replace(/^\/+/, '').replace(/\/+$/, '').split('/')[0];
    url.pathname = `/share-card/${encodeURIComponent(slug || 'untitled-share')}/${encodeShareAssetId(assetId)}/`;
    url.search = '';
    return url.toString();
  } catch (error) {
    const separator = baseUrl.includes('?') ? '&' : '?';
    return `${baseUrl}${separator}asset=${encodeURIComponent(assetId)}`;
  }
};

export const buildClientShareData = (link, url = buildShareUrl(link)) => ({
  title: link?.title || 'Sharabl asset link',
  text: link?.description || 'Controlled branded links for documents, photos, albums, and product catalogs.',
  url,
});
